import { render } from "./Topbar.vue?vue&type=template&id=15db2972"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"
script.render = render

export default script